module.exports = __webpack_public_path__ + "img/领域语义.23f22581.svg";